import axiosInstance from "../../utils/axiosInstance";
import { getAuthHeaders } from "../../utils/authHeader";

const BASE_URL = `/setting`;

export const createOrUpdateSetting = async (data) => {
  const res = await axiosInstance.post(
    `${BASE_URL}/upsert`,
    data,
    getAuthHeaders(),
  );
  return res.data;
};

export const getSettingByUser = async (search = "") => {
  const res = await axiosInstance.get(`${BASE_URL}/me`, {
    ...getAuthHeaders(),
    params: {
      search,
    },
  });

  return res.data;
};

export const deleteSettingByUuid = async (uuid) => {
  const res = await axiosInstance.delete(
    `${BASE_URL}/${uuid}`,
    getAuthHeaders(),
  );
  return res.data;
};

export const getSettingByUuid = async (settingUuid) => {
  const res = await axiosInstance.get(
    `${BASE_URL}/id/${settingUuid}`,
    getAuthHeaders(),
  );
  return res.data;
};
